import { combineReducers } from 'redux';

import columnsReducer from './ducks/columns';
import containerReducer from './ducks/container';
import queryReducer from './ducks/query';
import rdcReducers from './ducks/rdc/reducers';

const reducers = {
  columns: columnsReducer,
  container: containerReducer,
  query: queryReducer,
  rdc: rdcReducers,
};

export default combineReducers(reducers);
